var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrythmiaFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_152_1",
    "data-name": "Component 152 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.995,
    height: 28.369,
    viewBox: "0 0 28.995 28.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M23.8,5.376a7.55,7.55,0,0,0-9.794-.768A7.526,7.526,0,0,0,4.211,15.987l7.454,7.466a3.337,3.337,0,0,0,4.681,0L23.8,15.987a7.526,7.526,0,0,0,0-10.611Zm-1.692,8.954-7.454,7.454a.912.912,0,0,1-1.3,0L5.9,14.295a5.092,5.092,0,0,1,7.2-7.2,1.2,1.2,0,0,0,1.7,0,5.127,5.127,0,0,1,7.3,7.2Z",
    transform: "translate(-1.988 -3.121)",
    fill: "#023f7f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(10.995 10.369)",
    fill: "#eff0f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M-9730.559-5208.227l4.371,4.371v5.379l2.34-2.341v-3.038l4.371-4.371Z",
    transform: "translate(9745.192 5223.766)",
    fill: "none",
    stroke: "#023f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrythmiaFilter);
export default __webpack_public_path__ + "static/media/arrythmia-filter.a36b3b176a3e60d58296b771bb25bc65.svg";
export { ForwardRef as ReactComponent };